import React, { useState, useEffect } from 'react';
import { Icon } from "@iconify/react";
import "../styles/alert.css";

/* This component is used to show feedback messages whenever some action is performed by the user */
const CustomAlertWithButtons = ({
  title,
  type,
  message,
  button1Text = "Button 1",
  button2Text = "Button 2",
  onButton1Click,
  onButton2Click,
  showCheckbox = false,
  checkboxLabel = '',
  checkboxValue = false,
  onCheckboxChange = () => {}
}) => {

  const [isVisible, setIsVisible] = useState(true);

  // Reset visibility when component is re-rendered (when parent shows the alert again)
  useEffect(() => {
    setIsVisible(true);
  }, [title, message]); // Reset when key props change


  // Define the icon mapping based on the type
  const iconMap = {
    success: <Icon icon="ep:success-filled" width="24" height="24" />,
    warning: <Icon icon="mingcute:alert-fill" width="24" height="24" />,
    error: <Icon icon="mingcute:alert-fill" width="24" height="24" />,
  };

  // Check type and parse icon accordingly
  const icon = iconMap[type];

  // Button Actions
  const handleButton1Click = () => {
    if (onButton1Click) onButton1Click();
    setIsVisible(false);
  };

  const handleButton2Click = () => {
    if (onButton2Click) onButton2Click();
    setIsVisible(false);
  };

  const handleCheckboxChange = (e) => {
    // console.log('Checkbox handleCheckboxChange called with:', e.target.checked); // Debug log
    if (onCheckboxChange) onCheckboxChange(e.target.checked);
  };

  // Don't render if not visible
  if (!isVisible) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="backdrop"></div>

      {/* Alert */}
      <div className={`custom-alert-with-actions alert-${type}`}>
        {icon && <div className="alert-icon">{icon}</div>}
        <h5>{title}</h5>
        <div className="alert-message">{message}</div>

        {showCheckbox && (
          <div style={{
            marginTop: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <input
              type="checkbox"
              id="alertCheckbox"
              checked={checkboxValue}
              onChange={handleCheckboxChange}
              style={{
                cursor: 'pointer',
                marginTop: '10px',
                marginLeft: '10px',
                flexShrink: 0
              }}
            />
            <label
              htmlFor="alertCheckbox"
              style={{
                cursor: 'pointer',
                marginBottom: 0,
                userSelect: 'none',
              }}
            >
              {checkboxLabel}
            </label>
          </div>
        )}

        <div className='custom-alert-actions'>
          <button onClick={handleButton1Click}>{button1Text}</button>
          <button onClick={handleButton2Click}>{button2Text}</button>
        </div>
      </div>
    </>
  );
};

export default CustomAlertWithButtons;
